import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { of, Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { QuicksightService } from "./quicksight.service";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class BrandingService {

   clientId: string | null = null;

  constructor(private http: HttpClient, private quicksightService: QuicksightService) {}

  getLogoPath(): Observable<string> {

    this.clientId = this.quicksightService.getClientCode();
    const defaultLogo = './assets/alight_worklife_logo_black.svg';

    if (!this.clientId) {
        return of(defaultLogo);
    }

    switch (this.clientId) {
        case '02346':
        case '2346':
            return this.getBrandingLogo(this.clientId, 'en_US', 'qqqqqqqqqqq').pipe(
            map((res: any) => res?.logo || defaultLogo),
            catchError(() => of(defaultLogo))
            );
        default:
            return of(defaultLogo);
    }
  }

  getBrandingLogo(clientId: string, locale: string, consumerReferenceId: string): Observable<{ url: string }> {
    const headers = new HttpHeaders({
      'alightrequestheader': JSON.stringify({
        clientId,
        locale,
        consumerReferenceId
      })
    });
    return this.http.get<{ url: string }>(
      environment.brandingApiUrl,
      { headers }
    );
  }
}
